import { render, staticRenderFns } from "./consultar-faturas.vue?vue&type=template&id=5c1b0342&"
import script from "./consultar-faturas.vue?vue&type=script&lang=ts&"
export * from "./consultar-faturas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports